import { Component, Inject, Injector, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormField, SmartFormComponent } from 'ngx-smart-form';
import { SharedModule } from 'src/app/_shared/shared.module';
import { PraticaProgressService } from 'src/app/_core/services/pratica-progress.service';
import { FarmingInfo } from '../farming-info-table/models/farming-info';
import { getFarmingsDataFields } from './farming-fields';

@Component({
  standalone: true,
  selector: 'app-farming-info-dialog',
  templateUrl: './farming-info-dialog.component.html',
  styleUrls: ['./farming-info-dialog.component.scss'],
  imports: [SharedModule],
})
export class FarmingInfoDialogComponent {
  @ViewChild(SmartFormComponent)
  farmingsFormComponent?: SmartFormComponent<FarmingInfo>;

  fields: FormField<FarmingInfo>[][] = [];

  title = 'Allevamento';

  constructor(
    public praticaProgressService: PraticaProgressService,
    public dialogRef: MatDialogRef<
      FarmingInfoDialogComponent,
      Partial<FarmingInfo>
    >,
    @Inject(MAT_DIALOG_DATA)
    public data: { farming: FarmingInfo },
    private inj: Injector
  ) {}

  ngOnInit() {
    this.fields = getFarmingsDataFields(this.data.farming, this.inj);
  }

  save() {
    const farmingsDataForm = this.farmingsFormComponent?.form.value || {};
    this.dialogRef.close(farmingsDataForm);
  }

  get isFormValid() {
    return this.farmingsFormComponent?.form.valid;
  }
}
